module.exports = __webpack_public_path__ + "static/media/StepguideSpiderDOA.1c691acf.PNG";